export const HEADER_BLOCK_SIZE = 553
export const HEADER_HEIGHT = 80
export const MOBILE_HEADER_HEIGHT = 80

// Inject key mappings
export enum INJECT {
    ICON_CONTAINER = 'ICON_CONTAINER',
}